const locale = 'fr-FR';
const precision = 2;
// &nbsp; unicode replacement, as our font doesn't display
// correctly thousand separator from JS
const thousandSeparator = '\u00A0';

const vueCurrencyInputOptions = {
  currency: null,
  locale,
  precision,
};

export { vueCurrencyInputOptions };

export function currency(amount) {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'EUR',
  }).format(amount).replace(' ', thousandSeparator);
}

export function currencyNoDecimal(amount) {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount).replace(' ', thousandSeparator);
}

export function number(amount) {
  return new Intl.NumberFormat(locale, {
    style: 'decimal',
  }).format(amount).replace(' ', thousandSeparator);
}

/**
 * Format input number 10000 to 10 000 for example (3 digits)
 * @param {*} amount
 * @returns
 */
export function inputNumber(amount) {
  const cleanAmount = amount.replace(/\s/g, '');
  return cleanAmount.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

/**
 * Format input number to remove special character
 * @param {*} amount
 * @returns
 */
export function inputNumberRemoveSpecialChar(amount) {
  const amountValue = amount.toString();
  const stringNumber = amountValue.replace(/[^\d.,]/g, '').replace(/,/g, '.');
  return parseFloat(stringNumber);
}

export function numberOptionalDecimal(amount, decimalPrecision = 1) {
  const numberPrecision = amount === Math.round(amount) ? 0 : decimalPrecision;

  return new Intl.NumberFormat(locale, {
    style: 'decimal',
    minimumFractionDigits: numberPrecision,
    maximumFractionDigits: numberPrecision,
  }).format(amount).replace(' ', thousandSeparator);
}

export function displayCurrencyWithoutCurrencyCode(amount) {
  return new Intl.NumberFormat(locale, {
    style: 'decimal',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
}
